import { FC, useEffect, useState } from "react";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";
import { Box, FormHelperText, Grid, InputLabel, Tooltip } from "@mui/material";
import Editor from "../../../clientAdmin/components/settings/Editor/Editor";

const FormEditorComponents: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [editorValue, setEditorValue] = useState<string>("");

  // Synchronize editor value whenever props.value changes
  useEffect(() => {
    const newValue = String(props.value ?? "");
    setEditorValue(newValue);
  }, [props.value]);

  const handleEditorChange = (content: string) => {
    setEditorValue(content);

    // Pass the event structure with `id` and `value`
    if (props.onChange) {
      props.onChange({
        target: {
          id: props?.id,
          value: content,
        },
      });
    }
  };

  const inputRender = (isInGrid: boolean) => {
    return (
      <Box
        onBlurCapture={() => {
          if (props.onBlur) {
            props.onBlur({
              target: {
                id: props?.id,
                value: editorValue,
              },
            });
          }
        }}
      >
        <Editor
          id={props.id}
          value={editorValue}
          placeholders={props?.placeholderValue ?? null}
          editorConfig={props?.editorConfig}
          onChange={handleEditorChange}
        />
        {props?.error && props?.helperText && (
          <FormHelperText error sx={{ marginLeft: "14px", marginTop: "4px" }}>
            {props?.helperText}
          </FormHelperText>
        )}
      </Box>
    );
  };
  return (
    <>
      {props?.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{
              marginTop: props?.isNonMarginTop ? "0px !important" : "",
              backgroundColor: props?.lblBackgroundColor ?? "",
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              paddingTop: "16px",
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 12}
            sx={{
              display: "block",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#637381",
                  fontWeight: 600,
                  fontSize: "16px",
                  textAlign: "left !important",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
            {inputRender(true)}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormEditorComponents;
